import { assert } from '@ember/debug';
import { guidFor } from '@ember/object/internals';
import EmberOrderedSet from '@ember/ordered-set';
export default class EmberDataOrderedSet extends EmberOrderedSet {
  static create() {
    return new this();
  }
  addWithIndex(obj, idx) {
    var guid = guidFor(obj);
    var presenceSet = this.presenceSet;
    var list = this.list;
    if (presenceSet[guid] === true) {
      return;
    }
    presenceSet[guid] = true;
    if (idx === undefined || idx === null) {
      list.push(obj);
    } else {
      list.splice(idx, 0, obj);
    }
    this.size += 1;
    return this;
  }
  deleteWithIndex(obj, idx) {
    var guid = guidFor(obj);
    var presenceSet = this.presenceSet;
    var list = this.list;
    if (presenceSet[guid] === true) {
      delete presenceSet[guid];
      assert('object is not present at specified index', idx === undefined || list[idx] === obj);
      var index = idx !== undefined ? idx : list.indexOf(obj);
      if (index > -1) {
        list.splice(index, 1);
      }
      this.size = list.length;
      return true;
    } else {
      return false;
    }
  }
}